import { AppStandardButton } from "../../UI/AppButtons";
import React, { useEffect, useState } from "react";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import i18n from "../../../config/i18n";
import BookingGetters from "../../../store/onlineBooking/getters";

export function SignUpSuccess() {
  const [bookCarData, setBookCarData] = useState<string>("");
  const { t: translate } = useTranslation();
  const locationLang = i18n.language;
  const textResourceDetails =
    BookingGetters.getTextResourceDetailsBasedOnLang();
  const textResourceData =
    textResourceDetails?.[locationLang]?.flatMap((item) => item.data || []) ||
    [];
  useEffect(() => {
    const bookingCarTextData = textResourceData.find(
      (item) => item.key === "bookCar"
    );
    setBookCarData(bookingCarTextData?.body || t("Book a car"));
  }, [textResourceData, locationLang, translate]);

  return (
    <section className="min-h-[80vh] box-border px-10 md:px-44  flex flex-col border-t-2 border-solid border-grey-300">
      <header className="grow flex flex-col items-center justif-center gap-4 box-border py-8">
        <img src="/assets/images/success-icon@2x.png" className="h-36 w-36" />
        <h1 className="text-3xl font-bold text-[#004188] py-2 text-center">
          {t("Thank you! Your Registration Is Successful")}
        </h1>
        <p className="font-bold text-black-600">
          {/* Reservation Code:{" "} */}
          {/* Web Check In Code:{" "}
            <span className="font-bold text-[#5cbc14]">DG-87450</span> */}
        </p>
        <div className="flex flex-col-2 ">
          {" "}
          <AppStandardButton
            href="/"
            className={"w-fit py-4 sm:mx-0 md:mx-8"}
            variant="contained"
            color="secondaryColor"
            style={{ borderRadius: "5" }}
          >
            {/* Go to Account */}
            <span className="normal-case text-[#ffffff] text-lg">
              {" "}
              {bookCarData}
            </span>
          </AppStandardButton>
          <AppStandardButton
            href="/"
            className={"w-fit py-4 px-2 sm:mx-0 md:mx-8"}
            color="secondaryColor"
            variant="outlined"
            style={{ borderRadius: "5" }}
          >
            {/* Go to Account */}
            <span className="normal-case text-[primary] p-1 text-lg">
              {" "}
              Dashboard
            </span>
          </AppStandardButton>
        </div>
      </header>
      <main></main>
      <footer className="text-gray-600 box-border pb-32">
        {/* Web Checkin Info */}
        {/* Web Checkin Information */}

        <div className="box-border border-2 border-solid border-grey-200 px-8"></div>
      </footer>
    </section>
  );
}
